<template>
  <v-dialog v-model="_dialogCenario" scrollable eager max-width="100vw">
    <v-card>
      <v-card-title primary-title class="headline">Cenário {{ _cenario.id }}</v-card-title>

      <v-card-text v-if="_cenario.loading" class="pt-2">
        <v-row align="center" justify="center">
          <v-progress-circular indeterminate color="black" size="100" width="2" class="my-5" />
        </v-row>
      </v-card-text>

      <v-card-text v-else class="pt-2">
        <v-row class="mx-auto" no-gutters>
          <v-col cols="12">
            <highcharts :options="cenarioChartOptions" />
          </v-col>
        </v-row>

        <v-row align="center" justify="space-around" no-gutters>
          <v-col cols="6" sm="auto" style="font-size: 12px; font-weight: normal" class="px-1">
            <v-icon color="#69B34C" class="mb-1" v-text="'mdi-circle'" />
            Percentual depreciado entre 0% e 20%
          </v-col>
          <v-col cols="6" sm="auto" style="font-size: 12px; font-weight: normal" class="px-1">
            <v-icon color="#ACB334" class="mb-1" v-text="'mdi-circle'" />
            Percentual depreciado entre 20% e 40%
          </v-col>
          <v-col cols="6" sm="auto" style="font-size: 12px; font-weight: normal" class="px-1">
            <v-icon color="#FF8E15" class="mb-1" v-text="'mdi-circle'" />
            Percentual depreciado entre 40% e 60%
          </v-col>
          <v-col cols="6" sm="auto" style="font-size: 12px; font-weight: normal" class="px-1">
            <v-icon color="#FF4E11" class="mb-1" v-text="'mdi-circle'" />
            Percentual depreciado entre 60% e 80%
          </v-col>
          <v-col cols="6" sm="auto" style="font-size: 12px; font-weight: normal" class="px-1">
            <v-icon color="#FF0D0D" class="mb-1" v-text="'mdi-circle'" />
            Percentual depreciado entre 80% e 100%
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-btn
          :disabled="_cenario.loading"
          :loading="loadingSetarCenario"
          title="Ao setar esse cenário para a predição de baixas, esse gráfico poderá ser utilizado como fonte de dados para processamento de outras ferramentas"
          color="primary"
          @click="$emit('setarCenarioTriggered', { titulo: _cenario.id, faixa: _cenario.faixa, variavel: variavel })"
        >
          Setar Cenário
        </v-btn>
        <v-spacer />
        <v-btn text @click.stop="_dialogCenario = false">Fechar</v-btn>
        <v-btn :disabled="_cenario.loading" color="primary" @click="$emit('baixarCenarioTriggered', _cenario.faixa)">
          Baixar Cenário
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import dateFormatterMixins from '@/mixins/dateFormatterMixins';

  export default {
    name: 'DialogGraficoCenario',
    mixins: [dateFormatterMixins],

    props: {
      base: {
        type: String,
        default: ''
      },
      variavel: {
        type: String,
        default: ''
      },
      dialogCenario: {
        type: Boolean,
        default: false
      },
      cenario: {
        type: () => Object,
        default: {}
      },
      loadingSetarCenario: {
        type: Boolean,
        default: false
      }
    },

    emits: ['setarCenarioTriggered', 'baixarCenarioTriggered', 'update:dialogCenario', 'update:cenario'],

    computed: {
      _dialogCenario: {
        get() {
          return this.dialogCenario;
        },
        set(newValue) {
          this.$emit('update:dialogCenario', newValue);
        }
      },
      _cenario: {
        get() {
          return this.cenario;
        },
        set(newValue) {
          this.$emit('update:cenario', newValue);
        }
      },
      cenarioChartData() {
        if (this._cenario.dados.grafico == undefined) return [];

        if (this.base === 'ais') {
          return this._cenario.dados.grafico.map((dado) => {
            if (['voc', 'voc residual'].includes(this.variavel)) {
              return {
                x: this.variavel === 'voc' ? parseFloat(dado.voc) : parseFloat(dado.residual),
                y: parseFloat(dado.qtd_original),
                IMOBILIZADO: parseFloat(dado.imobilizado),
                SUBNUMERO: parseFloat(dado.subnumero),
                DATA_IMOBILIZACAO: this.formatDate(dado.data_imobilizacao),
                TUCAGEM: dado.tucagem,
                VOC: parseFloat(dado.voc),
                DEP_VOC: parseFloat(dado.dep_voc),
                RESIDUAL: parseFloat(dado.residual),
                TOTALMENTE_DEPRECIADO: parseFloat(dado.totalmente_depreciado),
                QTD_BAIXA: parseFloat(dado.qtd_baixa),
                VOC_BAIXA: parseFloat(dado.voc_baixa),
                TAXA_DEP: parseFloat(dado.taxa_dep),
                color: this.getPointColorCenarioChart(parseFloat(dado.taxa_dep))
              };
            } else if (['vnr', 'vnr residual'].includes(this.variavel)) {
              return {
                x: this.variavel === 'vnr' ? parseFloat(dado.vrn) : parseFloat(dado.residual_vnr),
                y: parseFloat(dado.qtd_original),
                IMOBILIZADO: parseFloat(dado.imobilizado),
                SUBNUMERO: parseFloat(dado.subnumero),
                DATA_IMOBILIZACAO: this.formatDate(dado.data_imobilizacao),
                TUCAGEM: dado.tucagem,
                VNR: parseFloat(dado.vnr),
                DEP_VNR: parseFloat(dado.dep_vnr),
                RESIDUAL_VNR: parseFloat(dado.residual_vnr),
                TOTALMENTE_DEPRECIADO: parseFloat(dado.totalmente_depreciado),
                QTD_BAIXA: parseFloat(dado.qtd_baixa),
                VNR_BAIXA: parseFloat(dado.vnr_baixa),
                TAXA_DEP: parseFloat(dado.taxa_dep),
                color: this.getPointColorCenarioChart(parseFloat(dado.taxa_dep))
              };
            }
          });
        } else if (this.base === 'laudo') {
          return this._cenario.dados.grafico.map((dado) => {
            if (['voc', 'voc residual'].includes(this.variavel)) {
              return {
                x: this.variavel === 'voc' ? parseFloat(dado.voc) : parseFloat(dado.residual),
                y: parseFloat(dado.qtd_original),
                DT_LCMTO: this.formatDate(dado.dt_lcmto),
                TUCAGEM: dado.tucagem,
                VOC: parseFloat(dado.voc),
                DEP_VOC: parseFloat(dado.dep_voc),
                RESIDUAL: parseFloat(dado.residual),
                QTD_BAIXA: parseFloat(dado.qtd_baixa),
                VOC_BAIXA: parseFloat(dado.voc_baixa),
                TAXA_DEP: parseFloat(dado.taxa_dep),
                color: this.getPointColorCenarioChart(parseFloat(dado.taxa_dep))
              };
            } else if (['vnr', 'vnr residual'].includes(this.variavel)) {
              return {
                x: this.variavel === 'vnr' ? parseFloat(dado.vnr) : parseFloat(dado.residual_vnr),
                y: parseFloat(dado.qtd_original),
                DT_LCMTO: this.formatDate(dado.dt_lcmto),
                TUCAGEM: dado.tucagem,
                VNR: parseFloat(dado.vnr),
                DEP_VNR: parseFloat(dado.dep_vnr),
                RESIDUAL_VNR: parseFloat(dado.residual_vnr),
                QTD_BAIXA: parseFloat(dado.qtd_baixa),
                VNR_BAIXA: parseFloat(dado.vnr_baixa),
                TAXA_DEP: parseFloat(dado.taxa_dep),
                color: this.getPointColorCenarioChart(parseFloat(dado.taxa_dep))
              };
            }
          });
        }

        return [];
      },
      cenarioChartOptions() {
        return {
          chart: {
            type: 'scatter',
            zoomType: 'xy'
          },
          boost: {
            enabled: this.cenarioChartData.length >= 50 ? true : false,
            seriesThreshold: 1
          },
          title: {
            text: ''
          },
          subtitle: {
            text: ''
          },
          xAxis: {
            title: {
              enabled: true,
              text: this.variavel.toUpperCase()
            }
          },
          yAxis: {
            title: {
              enabled: true,
              text: 'QTD'
            }
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            scatter: {
              marker: {
                radius: 5,
                states: {
                  hover: {
                    enabled: true,
                    lineColor: 'black'
                  }
                }
              },
              tooltip: {
                outside: false,
                headerFormat: '',
                pointFormat: this.getTooltipText()
              }
            }
          },
          tooltip: {
            snap: 100
          },
          series: [
            {
              boostThreshold: 50,
              turboThreshold: 0,
              name: 'Percentual depreciado',
              data: this.cenarioChartData
            }
          ],
          lang: {
            noData: 'Não há dados',
            resetZoom: 'Reiniciar Zoom',
            resetZoomTitle: 'Reiniciar Zoom'
          },
          noData: {
            style: {
              fontWeight: 'bold',
              fontSize: '15px',
              color: '#303030'
            }
          }
        };
      }
    },

    methods: {
      getPointColorCenarioChart(taxaDep) {
        // Source: https://www.schemecolor.com/red-orange-green-gradient.php
        const colors = ['#69B34C', '#ACB334', '#FF8E15', '#FF4E11', '#FF0D0D'];

        if (taxaDep <= 20.0) {
          return colors[0];
        } else if (taxaDep <= 40.0) {
          return colors[1];
        } else if (taxaDep <= 60.0) {
          return colors[2];
        } else if (taxaDep <= 80.0) {
          return colors[3];
        } else {
          return colors[4];
        }
      },
      getTooltipText() {
        if (this.base === 'ais') {
          if (['voc', 'voc residual'].includes(this.variavel)) {
            return `
            <b>PERCENTUAL DEPRECIADO: </b>{point.TAXA_DEP}%<br>
            <b>IMOBILIZADO:</b> {point.IMOBILIZADO}<br>
            <b>SUBNUMERO:</b> {point.SUBNUMERO}<br>
            <b>DATA DE IMOBILIZAÇÃO:</b> {point.DATA_IMOBILIZACAO}<br>
            <b>TUCAGEM:</b> {point.TUCAGEM}<br>
            <b>VOC:</b> {point.VOC}<br>
            <b>DEP_VOC:</b> {point.DEP_VOC}<br>
            <b>RESIDUAL:</b> {point.RESIDUAL}<br>
            <b>TOTALMENTE DEPRECIADO:</b> {point.TOTALMENTE_DEPRECIADO}<br>
            <b>QTD:</b> {point.y}<br>
            <b>QTD BAIXADA:</b> {point.QTD_BAIXA}<br>
            <b>VOC BAIXADO:</b> {point.VOC_BAIXA}<br>
          `;
          } else if (['vnr', 'vnr residual'].includes(this.variavel)) {
            return `
            <b>PERCENTUAL DEPRECIADO: </b>{point.TAXA_DEP}%<br>
            <b>IMOBILIZADO:</b> {point.IMOBILIZADO}<br>
            <b>SUBNUMERO:</b> {point.SUBNUMERO}<br>
            <b>DATA DE IMOBILIZAÇÃO:</b> {point.DATA_IMOBILIZACAO}<br>
            <b>TUCAGEM:</b> {point.TUCAGEM}<br>
            <b>VNR:</b> {point.VNR}<br>
            <b>DEP_VNR:</b> {point.DEP_VNR}<br>
            <b>RESIDUAL_VNR:</b> {point.RESIDUAL_VNR}<br>
            <b>TOTALMENTE DEPRECIADO:</b> {point.TOTALMENTE_DEPRECIADO}<br>
            <b>QTD:</b> {point.y}<br>
            <b>QTD BAIXADA:</b> {point.QTD_BAIXA}<br>
            <b>VNR BAIXADO:</b> {point.VNR_BAIXA}<br>
          `;
          }
        } else if (this.base === 'laudo') {
          if (['voc', 'voc residual'].includes(this.variavel)) {
            return `
            <b>PERCENTUAL DEPRECIADO: </b>{point.TAXA_DEP}%<br>
            <b>DATA DE LANÇAMENTO:</b> {point.DT_LCMTO}<br>
            <b>TUCAGEM:</b> {point.TUCAGEM}<br>
            <b>VOC:</b> {point.VOC}<br>
            <b>DEP_VOC:</b> {point.DEP_VOC}<br>
            <b>RESIDUAL:</b> {point.RESIDUAL}<br>
            <b>QTD:</b> {point.y}<br>
            <b>QTD BAIXADA:</b> {point.QTD_BAIXA}<br>
            <b>VOC BAIXADO:</b> {point.VOC_BAIXA}<br>
          `;
          } else if (['vnr', 'vnr residual'].includes(this.variavel)) {
            return `
            <b>PERCENTUAL DEPRECIADO: </b>{point.TAXA_DEP}%<br>
            <b>DATA DE LANÇAMENTO:</b> {point.DT_LCMTO}<br>
            <b>TUCAGEM:</b> {point.TUCAGEM}<br>
            <b>VNR:</b> {point.VNR}<br>
            <b>DEP_VNR:</b> {point.DEP_VNR}<br>
            <b>RESIDUAL_VNR:</b> {point.RESIDUAL_VNR}<br>
            <b>QTD:</b> {point.y}<br>
            <b>QTD BAIXADA:</b> {point.QTD_BAIXA}<br>
            <b>VNR BAIXADO:</b> {point.VNR_BAIXA}<br>
          `;
          }
        }
      },
      clearCenario() {
        this._cenario = {
          faixa: '',
          id: '',
          cenarioEscolhido: '',
          dados: {},
          loading: false
        };
      }
    },

    watch: {
      _dialogCenario(newValue) {
        if (newValue == false) {
          this.clearCenario();
        }
      }
    }
  };
</script>

<style>

</style>